import { useMutation, useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "@/api/constants";
import { RESOURCE_QUERY_META } from "@/api/resourceQuery";
import { clearWizardDraft } from "@/modules/wizardDraft";
import type { PaginationParams } from "@/types/api";

import { branchesApi } from "./branchApi";
import type { BranchId, IBranchFull, IBranchPaylad } from "./types";

export const useDeleteBranchMutation = () => {
  return useMutation({
    mutationFn: (id: BranchId) => {
      return branchesApi.deleteBranch(id);
    },
    onSuccess: (_data, id) => {
      clearWizardDraft("branch", id);
    },
  });
};

export const useUpdateBranchMutation = () => {
  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: BranchId;
      data: Partial<IBranchPaylad>;
    }) => {
      return branchesApi.patchBranch(id, data);
    },
  });
};

export const useGetAllBranchesQuery = (
  params?: PaginationParams,
  options = {}
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.branches, params],
    queryFn: () => branchesApi.getAllBranches(params),
    ...options,
  });
};

export const useGetBranchByIdQuery = (id: BranchId) => {
  return useQuery<IBranchFull>({
    queryKey: [QUERY_KEYS.branches, id],
    queryFn: () => branchesApi.getBranchById(id),
    enabled: !!id,
    meta: RESOURCE_QUERY_META,
    staleTime: 0,
    refetchOnMount: true,
  });
};

export const useGetBranchAvailableLegalEntityByBrandIdQuery = (
  brandId: string
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.branchAvailableLegalEntity, brandId],
    queryFn: () => branchesApi.getBranchAvailableLegalEntityByBrandId(brandId),
    enabled: !!brandId,
  });
};
